<template>
  <div>
    <vx-card class="mb-4 no-shadow">
      <div class="vx-row ml-1">
        <vs-button
          color="primary"
          class="mb-6"
          @click="clearFilters()"
        >
          Clear Filters
        </vs-button>
        <vs-button color='primary' class="mb-6 ml-2 px-2 py-1"  @click="initialize()" >
          <vs-icon icon="refresh" size="24px" class="pt-1" />
        </vs-button>
      </div>
      <vs-input
        class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg mb-4"
        type="text"
        label="Search"
        placeholder="Search..."
        size="large"
        v-model="search"
        v-on:keyup.enter="queryParams.search = search"
      />
      <div class="vx-row">
        <vs-select
          label="Orders per page"
          v-model="queryParams.limit"
          class="mr-4 vs-input-shadow-drop vs-select-no-border vx-col">
          <vs-select-item
            v-for="(val, index) in filterOptions.orderCount"
            :key="`order-count-${index}`"
            :value="val"
            :text="val"
          />
        </vs-select>
        <vs-select
          label="Order Status"
          v-model="selectedFilters.status"
          class="mr-4 vs-input-shadow-drop vs-select-no-border vx-col">
          <vs-select-item
            v-for="(val, index) in filterOptions.status"
            :key="`status-${index}`"
            :value="val.value"
            :text="val.text"
            is-selected.sync
          />
        </vs-select>
        <vs-select
          label="Shipment Status"
          v-model="selectedFilters['shipments.status']"
          class="mr-4 vs-input-shadow-drop vs-select-no-border vx-col">
          <vs-select-item
            v-for="(val, index) in filterOptions.shipmentStatus"
            :key="`status-${index}`"
            :value="val.value"
            :text="val.text"
            is-selected.sync
          />
        </vs-select>
        <vs-select
          label="Fulfillment"
          v-model="selectedFilters.fulfillmentType"
          class="mr-4 vs-input-shadow-drop vs-select-no-border vx-col">
          <vs-select-item
            v-for="(val, index) in filterOptions.fulfillment"
            :key="`fulfillment-${index}`"
            :value="val.value"
            :text="val.text"
            is-selected.sync
          />
        </vs-select>
        <vs-select
          label="Country"
          v-model="selectedFilters['shippingAddress.countryCode']"
          class="mr-4 vs-input-shadow-drop vs-select-no-border vx-col">
          <vs-select-item
            :value="null"
            text="All"
            is-selected.sync
          />
          <vs-select-item
            v-for="(val, index) in filterOptions.countries"
            :key="`country-${index}`"
            :value="val"
            :text="val"
            is-selected.sync
          />
        </vs-select>
        <vs-select
          label="Source"
          v-model="selectedFilters.source"
          class="mr-4 vs-input-shadow-drop vs-select-no-border vx-col">
          <vs-select-item
            :value="null"
            text="All"
            is-selected.sync
          />
          <vs-select-item
            v-for="(val, index) in filterOptions.source"
            :key="`country-${index}`"
            :value="val.value"
            :text="val.text"
            is-selected.sync
          />
        </vs-select>
      </div>
    </vx-card>

    <vs-table ref="table" class="pb-5" :data="orders">
      <template slot="thead">
        <vs-th v-for="(header, index) in headers" @click.native="header.property === 'skus' ? null : setOrderBy(header.property)" :key="`header-${index}`" >
          {{ header.text }}
          <feather-icon v-if="queryParams.sortBy === header.property" :icon="queryParams.orderDirection === -1 ? 'ChevronDownIcon' : 'ChevronUpIcon'" svgClasses="h-4 w-4" />
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody v-for="(order, index) in data" :data="orders" :key="index" @click="$router.push(`/orders/${order._id}`)">
          <vs-tr class="cursor-pointer">
            <vs-td>
              <p class="font-medium truncate">{{ order.orderNumber }}</p>
            </vs-td>
            <vs-td>
              <p class="font-medium truncate">{{ moment(order.shipTime).format('MM-DD-YYYY HH:mm A') }}</p>
            </vs-td>
            <vs-td>
              <p class="font-medium truncate">{{ order.billingAddress.firstName }} {{ order.billingAddress.lastName }}</p>
            </vs-td>
            <vs-td>
              <p class="font-medium truncate">{{ order.shippingAddress.countryCode }}</p>
            </vs-td>
            <vs-td>
              <p class="font-medium truncate">${{ order.totalPrice }}</p>
            </vs-td>
            <vs-td>
              <vs-tooltip :text="getSkus(order, true)" position="top" color="primary" >
                <p class="font-medium truncate">{{ getSkus(order) }}</p>
              </vs-tooltip>
            </vs-td>
            <vs-td>
              <p class="font-medium truncate">{{ order.status.split('_').join(' ') }}</p>
            </vs-td>
            <vs-td>
              <p class="font-medium truncate">{{ order.fulfillmentType }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>

    </vs-table>
    <vs-pagination
      :total="maxPage"
      :max="5"
      :value="page"
      @input="(val) => { fetch(val) }"
      style="justify-content: flex-end; display: flex; align-items: center; margin-left: 0; width: 100%;"/>
  </div>
</template>

<script>
import api from "@/http/api";
import moment from 'moment';
import countryHelper from '@/helpers/countryStateHelper';

const preSetQueryParams = () => {
  return {
    limit: 25,
    search: null,
    filters: [],
    sortBy: 'shipTime',
    orderDirection: -1
  }
};

const preSetSelectedFilters = () => {
  return {
    status: null,
    source: null,
    ['shipments.status']: null,
    fulfillmentType: null,
    ['shippingAddress.countryCode']: null
  }
};

export default {
  data() {
    return {
      orders: [],
      maxPage: 2,
      orderIcon: 'ChevronDownIcon',
      page: 1,
      search: null,
      queryParams: preSetQueryParams(),
      filterOptions: {
        orderCount: [25, 50, 75, 100],
        countries:  countryHelper.getAllCountryCodes(),
        status: [
          { text: "All", value: null},
          { text: "Pending", value: 'pending' },
          { text: "In Queue", value: 'in_queue' },
          { text: "Awaiting Shipment", value: 'awaiting_shipment' },
          { text: "Shipped", value: 'shipped' },
          { text: "Partially Shipped", value: 'partially_shipped' },
          { text: "Cancelled", value: 'cancelled' },
          { text: "Unprocessable", value: 'unprocessable' }
        ],
        shipmentStatus: [
          { text: "All", value: null },
          { text: "Awaiting Shipment", value: "awaiting_shipment" },
          { text: "Shipped", value: "shipped" },
          { text: "Cancelled", value: "cancelled" },
          { text: "Out of Stock", value: "out_of_stock" },
        ],
        fulfillment: [
          { text: "All", value: null },
          { text: "Auto", value: "auto" },
          { text: "Manual", value: "manual" }
        ],
        source: [
          { text: 'All', value: null },
          { text: 'Shopify', value: 'shopify' },
          { text: 'Younify', value: 'younify' },
          { text: 'Secure Checkout', value: 'secure_checkout' },
        ]
      },
      selectedFilters: preSetSelectedFilters(),
      headers: [
        {
          property: 'orderNumber',
          text: 'Order Number'
        },
        {
          property: 'shipTime',
          text: 'Process Date'
        },
        {
          property: 'billingAddress.firstName',
          text: 'Customer'
        },
        {
          property: 'shippingAddress.countryCode',
          text: 'Country'
        },
        {
          property: 'totalPrice',
          text: 'Total'
        },
        {
          property: 'skus',
          text: 'Skus'
        },
        {
          property: 'status',
          text: 'Status'
        },
        {
          property: 'fulfillmentType',
          text: 'Fulfillment'
        }
      ]
    }
  },
  mounted() {
    this.initialize();
  },
  watch: {
    selectedFilters: {
      deep: true,
      handler() { this.setFilters(); }
    },
    queryParams: {
      deep: true,
      handler() {
        this.setStorageFilters();
        this.fetch()
      }
    }
  },
  methods: {
    moment: moment,
    async initialize() {
      const queryParams = localStorage.orderQueryParams ? JSON.parse(localStorage.orderQueryParams) : null;
      const orderFilters = localStorage.orderFilters ? JSON.parse(localStorage.orderFilters) : null;

      if (queryParams && orderFilters) {
        this.selectedFilters = orderFilters;
        this.queryParams = queryParams;
        this.search = queryParams.search;
      }
      else await this.fetch();
    },
    setStorageFilters() {
      localStorage.orderQueryParams = JSON.stringify(this.queryParams);
      localStorage.orderFilters = JSON.stringify(this.selectedFilters);
    },
    async fetch(page = 1) {
      this.$vs.loading();

      this.page = page;

      const result = await api.getOrders({...this.queryParams, page: this.page});
      this.orders = result.data
      this.maxPage = result.pagination.pages;

      this.requestNewPage = false;
      this.$vs.loading.close();
    },
    async setOrderBy(name) {
      const { orderDirection, sortBy } = this.queryParams;
      this.queryParams.orderDirection = orderDirection === -1 && sortBy === name ? 1 : -1;
      this.queryParams.sortBy = name;
    },
    async setFilters() {
      let filters = [];

      Object.keys(this.selectedFilters).map((key) => {
        const value = this.selectedFilters[key];
        if (!value) return;
        filters.push({ property: key, value: value });
      });

      this.queryParams.filters = filters;
    },
    clearFilters() {
      this.search = null;
      this.queryParams = preSetQueryParams();
      this.selectedFilters = preSetSelectedFilters();
    },
    orderDetailView(id) {
      this.$router.push(`/orders/${id}`);
    },
    getSkus(order, all = false){
      if (all) return order.lineItems.map(lineItem => ` ${lineItem.sku}`).toString();
      return order.lineItems.length === 1 ? order.lineItems[0].sku : 'Multiple';
    }
  }
}
</script>
